import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './notfound'
import Login from '@/components/client/views/Login'
import Home from '@/components/client/views/Home'
import Messages from '@/components/client/views/Messages'
import Files from '@/components/client/views/Files'
import Settings from '@/components/client/views/Settings'
import Forms from '@/components/client/views/Forms'
import Cases from '@/components/client/views/Cases'
import ClientForm from '@/components/client/views/forms/UserForm'
import UserFormSubmitted from '@/components/client/views/forms/UserFormSubmitted'
import auth from './auth'

Vue.use(Router)

const genericRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/files',
    name: 'Files',
    component: Files,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/cases',
    name: 'Cases',
    component: Cases,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/cases/:id?/',
    name: 'Forms',
    component: Forms,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/cases/:id?/:form_id?/',
    name: 'ClientForm',
    component: ClientForm,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/cases/:id?/:form_id?/submit',
    name: 'UserFormSubmitted',
    component: UserFormSubmitted,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/',
    redirect: {
      name: 'Home'
    }
  }
]

var routes = genericRoutes
routes = routes.concat(NotFound)
export default new Router({
  mode: 'history',
  routes
})
